<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="filters.parentInsider = searchByParentName.value; onSearch()"
    #searchByParentName
    type="text"
    placeholder="Search by parent name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, searchByParentName)"
  />
  <input
    (keydown.enter)="filters.childInsider = searchByChildName.value; onSearch()"
    #searchByChildName
    type="text"
    placeholder="Search by child name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, searchByChildName)"
  />
</div>

<div class="mb-4"></div>

<p-table
  [value]="list"
  [paginator]="list.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th>Parent Name</th>
      <th>Child Names</th>
    </tr>
  </ng-template>
  <ng-template #body let-issuer>
    <tr>
      <td>{{ issuer.parentName || "N/A" }}</td>
      <td style="white-space: pre-line">{{ issuer.childNames.split(' | ').join('\n') }}</td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>

<ng-container *ngIf="!isLoading && list.length === 0">
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-container>
